/**
 * Site root for static files. With homepage ".", CRA sets PUBLIC_URL to "."
 * which breaks on nested routes (e.g. /marketing/about → ./images → /marketing/images).
 */
export function publicUrlBase() {
  const raw = (process.env.PUBLIC_URL || '').trim();
  if (!raw || raw === '.' || raw === '/') return '';
  return raw.replace(/\/$/, '');
}

/**
 * Builds a root-absolute URL for files in /public/images (works on all routes).
 */
export function publicImageUrl(filenameOrPath) {
  const base = publicUrlBase();
  let name = filenameOrPath;
  if (name.startsWith('/images/')) {
    name = name.slice('/images/'.length);
  } else if (name.startsWith('images/')) {
    name = name.slice('images/'.length);
  }
  const segments = name.split('/').filter(Boolean);
  const encoded = segments.map((seg) => encodeURIComponent(seg)).join('/');
  return `${base}/images/${encoded}`;
}

export function publicAssetPath(path) {
  if (!path.startsWith('/images/')) {
    const base = publicUrlBase();
    return `${base}${path.startsWith('/') ? path : `/${path}`}`;
  }
  return publicImageUrl(path);
}
